//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import PosWorkstationUserListView from "@/views/General/GPosWorkstationUser/list"
import PosWorkstationUserCreateView from "@/views/General/GPosWorkstationUser/create"
import PosWorkstationUserUpdateView from "@/views/General/GPosWorkstationUser/update"

//
export default {
    path: "pos_workstation_users",
    component: ModuleLayout,
    children: [
        {
            name: "pos-workstation-user-list",
            path: "",
            component: PosWorkstationUserListView,
        },
        {
            name: "pos-workstation-user-create",
            path: "create",
            component: PosWorkstationUserCreateView,
            meta: {
                title: "Crear punto de venta"
            },
        },
        {
            name: "pos-workstation-user-update",
            path: ":id",
            component: PosWorkstationUserUpdateView,
            meta: {
                title: "Detalle de punto de venta"
            },
        },
    ],
    meta: {
        title: "Puntos de venta"
    },
}